(() => {
  const form = document.querySelector('[data-facet-form]');
  if (!form) return;
  const sort = document.querySelector('#MuseSort');
  const submit = () => form.requestSubmit();
  sort?.addEventListener('change', submit);
  form.querySelectorAll('[data-facet-auto]').forEach(input => input.addEventListener('change', submit));
  form.querySelectorAll('[data-sort-value]').forEach(button => button.addEventListener('click', () => {
    sort.value = button.dataset.sortValue;
    submit();
  }));
  const prices = [...form.querySelectorAll('input[name^="filter.v.price."]')];
  prices.forEach(input => input.addEventListener('input', () => prices.forEach(price => price.setCustomValidity(''))));
  form.addEventListener('submit', event => {
    const [minimum, maximum] = prices;
    if (minimum?.value && maximum?.value && Number(minimum.value) > Number(maximum.value)) {
      event.preventDefault();
      maximum.setCustomValidity('The maximum price must be greater than or equal to the minimum price.');
      maximum.reportValidity();
    }
  });
})();
